import { render, staticRenderFns } from "./tag-statistics.vue?vue&type=template&id=b0c8f924&scoped=true&"
import script from "./tag-statistics.vue?vue&type=script&lang=ts&"
export * from "./tag-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./tag-statistics.vue?vue&type=style&index=0&id=b0c8f924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c8f924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0c8f924')) {
      api.createRecord('b0c8f924', component.options)
    } else {
      api.reload('b0c8f924', component.options)
    }
    module.hot.accept("./tag-statistics.vue?vue&type=template&id=b0c8f924&scoped=true&", function () {
      api.rerender('b0c8f924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/tag-statistics.vue"
export default component.exports